// src/components/Sidebar.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';
import './Sidebar.css';
import logo from '../logo.png';

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const [hasRHModule, setHasRHModule] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkRHModule();
  }, []);

  const checkRHModule = async () => {
    try {
      const user = authService.getCurrentUser();
      if (user?.companyId) {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/companies/${user.companyId}/rh-option`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
        });
        const data = await response.json();
        setHasRHModule(data.success && data.data?.hasRHOption === true);
      }
    } catch (error) {
      console.error('Erreur vérification module RH:', error);
    } finally {
      setLoading(false);
    }
  };

  const menuItems = [
    { path: '/', label: 'Actualités', icon: '🔔' },
    { path: '/employees', label: 'Employés', icon: '👥' },
    { path: '/offers', label: 'Offres', icon: '🎁' },
    { path: '/validation', label: 'Validation', icon: '📋' }
  ];

  // Ajouter le menu RH conditionnellement
  if (hasRHModule) {
    menuItems.push({ path: '/rh', label: 'Gestion RH', icon: '🧑' });
  }

  if (loading) {
    return (
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img src={logo} alt="Logo" className="logo-image" />
          </div>
        </div>
        <div className="sidebar-nav">Chargement...</div>
      </div>
    );
  }

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <div className="logo-icon">
            <img src={logo} alt="Logo Avantagea" className="logo-image" />
          </div>
          <div className="logo-text">
            <h2 className="logo-title">Avantagea</h2>
            <p className="logo-subtitle">Espace Client</p>
          </div>
        </div>
      </div>
      
      <nav className="sidebar-nav">
        {menuItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={onClose}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
            <div className="nav-indicator"></div>
          </Link>
        ))}
      </nav>
      
      <div className="sidebar-footer">
        <div className="sidebar-status">
          <div className="status-dot"></div>
          <span className="status-text">Système en ligne</span>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;